import { render } from "./result-link-button.vue?vue&type=template&id=23fef998"
import script from "./result-link-button.vue?vue&type=script&lang=js"
export * from "./result-link-button.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__